module.exports = __webpack_public_path__ + "img/ma_rosario.c7737462.jpg";